import React from 'react'

import { TabelaColuna } from 'src/componentes'

export const colunaNomeAluno = (): TabelaColuna => ({
  Chave: 'nomeAluno',
  StyleColuna: { width: 200 },
  RenderizarCabecalho: () => <div style={{ width: 200 }}>Aluno</div>
})
